<template>
  <div class="art-request-queue-page">
    <CCard class="mb-3">
      <CCardHeader>Art Request Queue</CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="12" md="3">
            <label class="field-label">Status</label>
            <v-select
              v-model="filters.status"
              :options="statusOptions"
              label="label"
              :reduce="option => option.value"
              @input="loadQueue"
            />
          </CCol>
          <CCol sm="12" md="3">
            <CInput label="Customer #" v-model="filters.customer_number" @keyup.enter="loadQueue" />
          </CCol>
          <CCol sm="12" md="3">
            <CInput label="Order ID" v-model="filters.order_id" @keyup.enter="loadQueue" />
          </CCol>
          <CCol sm="12" md="3" class="d-flex align-items-end">
            <CButton color="info" @click="loadQueue" :disabled="loading">
              {{ loading ? 'Loading...' : 'Refresh' }}
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CCard>
      <CCardHeader>Queued Requests</CCardHeader>
      <CCardBody>
        <div v-if="loading">Loading queue...</div>
        <div v-else-if="!items.length">No queued art requests found.</div>
        <div v-else class="table-responsive">
          <table class="table table-hover queue-table">
            <thead>
              <tr>
                <th>Order</th>
                <th>Status</th>
                <th>Type</th>
                <th>Customer</th>
                <th>Program</th>
                <th>Bundle</th>
                <th>Placement</th>
                <th>Technique</th>
                <th>Location</th>
                <th>Units</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td>
                  <router-link v-if="item.order_id" :to="'/order/' + item.order_id">
                    {{ item.order_id }}
                  </router-link>
                  <span v-else>—</span>
                </td>
                <td class="status-cell">
                  <v-select
                    :value="item.status"
                    :options="statusOptions"
                    label="label"
                    :reduce="option => option.value"
                    @input="updateStatus(item, $event)"
                  />
                </td>
                <td>{{ item.request_type }}</td>
                <td>{{ item.customer_number || '—' }}</td>
                <td>{{ item.program_name || '—' }}</td>
                <td>
                  <div>{{ item.bundle_name || '—' }}</div>
                  <div class="helper-text">{{ item.section_name || '' }}</div>
                </td>
                <td>{{ item.bundle_placement_name || '—' }}</td>
                <td>{{ item.technique_name || '—' }}</td>
                <td>{{ formatLocation(item) }}</td>
                <td>{{ item.units || 0 }}</td>
                <td>{{ formatDate(item.created_at) }}</td>
                <td>
                  <CButton size="sm" color="light" @click="openDetail(item)">View</CButton>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </CCardBody>
    </CCard>

    <art-request-action-modal
      :show.sync="detailOpen"
      :queue-id="selectedQueueId"
      @saved="loadQueue"
    />
  </div>
</template>

<script>
import ArtRequestActionModal from './art_request_action_modal'

export default {
  name: 'ArtRequestQueue',
  components: {
    ArtRequestActionModal
  },
  data () {
    return {
      loading: false,
      items: [],
      detailOpen: false,
      selectedQueueId: '',
      filters: {
        status: '',
        customer_number: '',
        order_id: ''
      },
      statusOptions: [
        { label: 'All', value: '' },
        { label: 'New', value: 'new' },
        { label: 'In Review', value: 'in_review' },
        { label: 'Ready To Submit', value: 'ready_to_submit' },
        { label: 'Submitted To Workflow', value: 'submitted_to_workflow' },
        { label: 'Completed', value: 'completed' },
        { label: 'Cancelled', value: 'cancelled' }
      ]
    }
  },
  mounted () {
    this.loadQueue()
  },
  methods: {
    loadQueue () {
      this.loading = true
      axios.get(this.$apiAdress + '/api/art_request_queues?token=' + localStorage.getItem('api_token'), {
        params: {
          status: this.filters.status || '',
          customer_number: this.filters.customer_number || '',
          order_id: this.filters.order_id || ''
        }
      }).then((response) => {
        this.items = response.data || []
        this.loading = false
      }).catch((error) => {
        this.loading = false
        this.$store.commit('axios_error', error)
      })
    },
    updateStatus (item, status) {
      if (!item || !item.id || !status || item.status === status) {
        return
      }
      axios.post(this.$apiAdress + '/api/art_request_queues/updateStatus?token=' + localStorage.getItem('api_token'), {
        id: item.id,
        status: status
      }).then(() => {
        item.status = status
      }).catch((error) => {
        this.$store.commit('axios_error', error)
      })
    },
    openDetail (item) {
      this.selectedQueueId = item && item.id ? item.id : ''
      this.detailOpen = true
    },
    formatDate (value) {
      if (!value) return '—'
      return new Date(value).toLocaleString()
    },
    formatLocation (item) {
      if (!item) return '—'
      return [item.location_code, item.location_name].filter(Boolean).join(' - ') || '—'
    }
  }
}
</script>

<style scoped>
.art-request-queue-page .field-label {
  font-weight: 600;
}

.queue-table td,
.queue-table th {
  vertical-align: middle;
}

.status-cell {
  min-width: 180px;
}

.helper-text {
  font-size: 12px;
  color: #7d8fa3;
}
</style>
